// extracted by mini-css-extract-plugin
export var avatarContainer = "_hx-0";
export var avatarTypingWave = "_hx-i";
export var gray = "_hx-f";
export var green = "_hx-c";
export var icon = "_hx-9";
export var image = "_hx-1";
export var lg = "_hx-6";
export var md = "_hx-5";
export var presenceDot = "_hx-b";
export var red = "_hx-d";
export var sm = "_hx-4";
export var status = "_hx-a";
export var typingDot = "_hx-h";
export var typingPill = "_hx-g";
export var xl = "_hx-7";
export var xs = "_hx-3";
export var xxl = "_hx-8";
export var xxs = "_hx-2";
export var yellow = "_hx-e";